// extracted by mini-css-extract-plugin
var _1 = "ApplicantDecisionPanel-moduleApplicantDecisionPanel__LvZEt";
var _2 = "ApplicantDecisionPanel-moduleactions__wX9jH";
var _3 = "ApplicantDecisionPanel-moduleapplicant__DILQ8";
var _4 = "ApplicantDecisionPanel-moduleapplicantActions__zc12r";
var _5 = "ApplicantDecisionPanel-moduleapplicantName__CCCNR";
var _6 = "ApplicantDecisionPanel-moduleapprovalPeople__TCotk";
var _7 = "ApplicantDecisionPanel-moduleledger__jHgJs";
var _8 = "ApplicantDecisionPanel-moduleledgerHead__yduoY";
var _9 = "ApplicantDecisionPanel-moduleledgerLabel__Pdnnq";
var _a = "ApplicantDecisionPanel-moduleledgerLabelRow__SeqGV";
var _b = "ApplicantDecisionPanel-moduleledgerRow__KqnjP";
var _c = "ApplicantDecisionPanel-moduleledgerStep__PQ1tY";
var _d = "ApplicantDecisionPanel-moduleledgerText__Tvd5t";
var _e = "ApplicantDecisionPanel-moduleledgerValue__niI05";
var _f = "ApplicantDecisionPanel-moduleline__GATko";
var _10 = "ApplicantDecisionPanel-modulemodalBody__nEuis";
var _11 = "ApplicantDecisionPanel-modulemodalGuardrail__GMg6a";
var _12 = "ApplicantDecisionPanel-modulemutedUser__xSsPC";
var _13 = "ApplicantDecisionPanel-modulenote__fcVNm";
var _14 = "ApplicantDecisionPanel-modulenoteLabel__fKpcy";
var _15 = "ApplicantDecisionPanel-modulenoteReadMore__PBiqV";
var _16 = "ApplicantDecisionPanel-modulenoteText__EbT1I";
var _17 = "ApplicantDecisionPanel-moduleuser__RHe1i";
export { _1 as "ApplicantDecisionPanel", _2 as "actions", _3 as "applicant", _4 as "applicantActions", _5 as "applicantName", _6 as "approvalPeople", _7 as "ledger", _8 as "ledgerHead", _9 as "ledgerLabel", _a as "ledgerLabelRow", _b as "ledgerRow", _c as "ledgerStep", _d as "ledgerText", _e as "ledgerValue", _f as "line", _10 as "modalBody", _11 as "modalGuardrail", _12 as "mutedUser", _13 as "note", _14 as "noteLabel", _15 as "noteReadMore", _16 as "noteText", _17 as "user" }
